var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "ContentHeader",
            { attrs: { title: "Sectors", bordered: false } },
            [
              _c(
                "template",
                { slot: "actions" },
                [
                  _vm.can("createMembers")
                    ? _c(
                        "router-link",
                        {
                          staticClass: "btn btn--primary",
                          attrs: { to: "/sectors/add" },
                        },
                        [_vm._v("Add Sector")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SectorGrid"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }